export default __webpack_public_path__ + "static/media/Chocolate.67728fa9.jpg";